export default __webpack_public_path__ + "81197aacc3396fca851ad0811f2aba26.svg";